export const MIR_SET_TITLE = "@@mirai/MIR_SET_TITLE";
export const MIR_TWIST_LOAD = "@@mirai/MIR_TWIST_LOAD";
export const MIR_PLAY_SHOW = "@@mirai/MIR_PLAY_SHOW";
export const UNAUTHED_REDIRECT = "@@mirai/UNAUTHED_REDIRECT";
